<template>
	<alert-log :serviceIcons="serviceIcons"></alert-log>
</template>

<script>
import AlertLog from './components/AlertLog.vue';

export default {
	components: { AlertLog },
	data() { return {
		serviceIcons: {},
	}},
	created() {
		this.$auth.loadFromLocalStorage();
		if(!this.$auth.isLoggedIn()) {
			document.location = `${process.env.VUE_APP_PIPIPUPUBASE}/app?redirect=${document.location}`;
			return;
		}
		this.$api.get('services').then(services => {
			for(const service of services)
				if(service.icon?.url) this.serviceIcons[service.id] = service.icon.url;
		});
	},
};
</script>

<style>
html, body, #app {
	height: 100%;
	margin: 0;
	padding: 0;
}

html.obs ::-webkit-scrollbar { width: 10px }
html.obs ::-webkit-scrollbar-track { background: #241e32 }
html.obs ::-webkit-scrollbar-thumb { background: #eb5dff; border-radius: 5px }
html.obs ::-webkit-scrollbar-thumb:hover { background: #5df286 }
</style>
